import React, { useEffect, useState } from 'react';
import {Redirect } from "react-router-dom";
import { useCoverLetter } from '../../context/CoverLetterContext';
import { 
  COVERLETTER_EXP_WORKHISTORY,
  COVERLETTER_LOGIN,
  COVERLETTER_FINALIZE,
  COVERLETTER_WORKSTYLE,
  COVERLETTER_PERSONALIZE
} from '../../constants/constants';
import '../../assets/scss/app/cover-letter-screens/on-bording-screens.scss';
import WpAPI from '../../WpApi';
import WorkStyleForm from './QuesAnsSections/WorkStyleForm';

const WorkStyle = (props) => {
    const [back, setBack] = useState(false);
    const [next, setNext] = useState(false);
    const [redirect2, setRedirect2] = useState(null);
    const { 
      ques_ans_response,
      qa_steps_initiated,
    handlers: {
        saveQA,
        loadQA,
        createCoverLetter,
        editInProgress
    },
  } = useCoverLetter();

  const saveForm = (data) => {
    saveQA({ ques_ans_response: {...ques_ans_response, ...data} })
  }
  useEffect(() => {
    //browser issue, page not opening at top
    window.scrollTo(0, 0)
    loadQA()
  }, []);
  useEffect(() => {
    // to handle if this is used to show popup and unhandled cases arises because of back button usages
    localStorage.removeItem('clickAction')
  }, []);
  useEffect(() => {
    (next || back) && history.pushState(null, COVERLETTER_WORKSTYLE)
    next && setRedirect2(WpAPI.isLoggedIn() ? COVERLETTER_FINALIZE : COVERLETTER_LOGIN )
    next && WpAPI.isLoggedIn() && createCoverLetter()
    back && setRedirect2(COVERLETTER_EXP_WORKHISTORY)
  }, [back, next]);

  if (redirect2) return <Redirect to={redirect2} />
  else if (editInProgress()) return <Redirect to={COVERLETTER_PERSONALIZE} />
  return (
    <div className="cover-screen-outer cover-work-style">
    <div className="screen-inner">
      <div className="block">
        <div className="progress-bar">
              <div className="bar-outer">
                  <div className="bar-inner work-style"></div>
              </div>
              <div className="bar-levels">
                  <div className="level-text"><span className="level-mark"></span>Select a Template</div>
                  <div className="level-text "><span className="level-mark"></span>Job Goals</div>
                  <div className="level-text active"><span className="level-mark"></span>Work Info</div>
                  <div className="level-text"><span className="level-mark"></span>Finalize</div>
              </div>
            </div>
        <div className="screen screen-six">
          <h1>How do you prefer to work?</h1>
          <p>We'll personalize the tone of your letter based on your working style.</p>
           <WorkStyleForm  data={{work_style: ques_ans_response.work_style}} save={(p)=>saveForm(p)}/>
          <div className="screen-action">
          <button className="round-btn" onClick={() => setBack(!back)}> <i className="arrow-bar-left"></i><span>Back</span></button>
          <button className="round-btn  active" onClick={() => setNext(!next)}><span>{WpAPI.isLoggedIn() ? 'Generate Cover Letter' : 'Next'}</span><i className="arrow-bar-right"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}

export default WorkStyle;